import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { GetContentService } from "src/app/Services/getcontent.service";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { PermissionsService } from "src/app/Services/permissions.service";
import { OrgContextService } from "src/app/Services/org-context.service";
import { testcmsconfig, prodcmsconfig } from "src/app/shared/cms/cmsconfig";
import { ContentQueryModel } from "src/app/shared/cms/contentquerymodel";
import { ContentTypes } from "src/app/shared/enums/content.types";
import {
  updateLoggedInUser,
} from "src/app/shared/utils/plan.util";
import { CreatorPlanConfirmDialogComponent } from "./creator-plan-confirm-dialog.component";
import {
  resolveCoinPurchaseReturnUrl,
  setCoinPurchaseReturnUrl,
} from "src/app/shared/utils/coin-purchase-return.util";
import { BundledialogComponent } from "../bundledialog/bundledialog.component";
import { AiCoinPurchaseDialogComponent } from "../ai-coin-purchase-dialog/ai-coin-purchase-dialog.component";
import { GuideSlotPurchaseDialogComponent } from "../guide-slot-purchase-dialog/guide-slot-purchase-dialog.component";
import { UpgradePlanDialogComponent } from "../upgrade-plan-dialog/upgrade-plan-dialog.component";
import {
  AiCoinBalance,
  AiCoinPack,
  AiCoinService,
  DEFAULT_AI_COIN_PACKS,
} from "src/app/Services/ai-coin.service";
import {
  DEFAULT_GUIDE_SLOT_PACKS,
  GuideSlotBalance,
  GuideSlotPack,
  GuideSlotService,
} from "src/app/Services/guide-slot.service";
import {
  PlanConfigModel,
  SubscriptionService,
  TrialStatusModel,
} from "src/app/Services/subscription.service";
import { TrialStateService } from "src/app/Services/trial-state.service";
import { isTrialEligible } from "src/app/shared/utils/trial.util";
import { FrontlineFeatureFlags } from "src/app/shared/constants/frontline-glossary";
import {
  formatOverageRates,
  formatViewOverageRate,
  formatViewsLimit,
  getPlanLimits,
  getTrialConfig,
  growthCoinsFeature,
  growthGuideFeature,
  growthViewsFeature,
  mergePlanConfig,
  starterCoinsFeature,
  starterGuideFeature,
  starterViewsFeature,
} from "src/app/shared/utils/plan-config.util";

@Component({
  selector: "app-pricingplan",
  templateUrl: "./pricingplan.component.html",
  styleUrls: ["./pricingplan.component.scss"],
})
export class PricingplanComponent implements OnInit {
  /** Soft-gate commerce add-ons (top-ups, coins, concierge) for frontline Keep delivery. */
  readonly showCommerceAddOns = FrontlineFeatureFlags.showCommerceAddOns;

  pricing: any = [];
  pricingPageObj: any;
  isLoading!: any;
  pageHeading!: string;
  tables: any = [
    {
      tableHeading: "Feature Comparison",
      tableRowModels: [
        {
          columnValue1: "Sign Up",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471527986895",
          displayOrder: 1,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Login",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471527444813",
          displayOrder: 2,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Logout",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471526584673",
          displayOrder: 3,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Forgot Password",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471525679978",
          displayOrder: 4,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Change Password",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471524768027",
          displayOrder: 5,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Edit Profile",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471523871697",
          displayOrder: 6,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Preview Profile",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471523027173",
          displayOrder: 7,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Follow Users",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471522371422",
          displayOrder: 8,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "User QR Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471521775633",
          displayOrder: 9,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Notification",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471521226250",
          displayOrder: 10,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Generate Coupons",
          columnValue2: "No",
          columnValue3: "1/Month",
          columnValue4: "Unlimited",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471520636630",
          displayOrder: 11,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Dashboard",
          columnValue2: "Yes",
          columnValue3: "No",
          columnValue4: "No",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471520075018",
          displayOrder: 12,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Create Guide",
          columnValue2: "1 free; Unlimited paid",
          columnValue3: "10 free; Unlimited paid\t",
          columnValue4: "Unlimited",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471519518075",
          displayOrder: 13,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Save Draft",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471518931147",
          displayOrder: 14,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "View Flow",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471518349671",
          displayOrder: 15,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Edit Flow",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471517752675",
          displayOrder: 16,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Delete Flow",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471517179853",
          displayOrder: 17,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Unique Flow Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471516571946",
          displayOrder: 18,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Flow QR Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471515933192",
          displayOrder: 19,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Share Flow (Direct)",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471515306552",
          displayOrder: 20,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Copy Embed Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471514645379",
          displayOrder: 21,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Copy Link",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471513958854",
          displayOrder: 22,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Like Flow",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471513293086",
          displayOrder: 23,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Comment on Flow",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471512711039",
          displayOrder: 24,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Save Flow",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471512092797",
          displayOrder: 25,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Reply Comment",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471511500375",
          displayOrder: 26,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Add Supporting Documents",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471510885003",
          displayOrder: 27,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Add Item Image",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471510264790",
          displayOrder: 28,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Add Item Link",
          columnValue2: "No",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471509600558",
          displayOrder: 29,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Purchase Guide",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471509025395",
          displayOrder: 30,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Estimated Time of Completion",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471508465069",
          displayOrder: 31,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Report as Inappropriate",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471507871758",
          displayOrder: 32,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Create Guide Pack",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471507306509",
          displayOrder: 33,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "View Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471506755976",
          displayOrder: 34,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Edit Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471506192876",
          displayOrder: 35,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Delete Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471505646113",
          displayOrder: 36,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Unique Bundle Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471505055568",
          displayOrder: 37,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Bundle QR Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471504502248",
          displayOrder: 38,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Share Bundle (Direct)",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471503954673",
          displayOrder: 39,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Copy Embed Code",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471503359951",
          displayOrder: 40,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Copy Link",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471502792578",
          displayOrder: 41,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Like Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471502224635",
          displayOrder: 42,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Comment on Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471501596236",
          displayOrder: 43,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Reply Comment",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471501021708",
          displayOrder: 44,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Save Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471500118291",
          displayOrder: 45,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Add Supporting Document",
          columnValue2: "No",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471499500513",
          displayOrder: 46,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Puchase Bundle",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471498872527",
          displayOrder: 47,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Report as Inappropriate",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471498268382",
          displayOrder: 48,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "About Us",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471497664173",
          displayOrder: 49,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Privacy Policy",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471497112603",
          displayOrder: 50,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Terms and Conditions",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471496535499",
          displayOrder: 51,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Third Party Libraries",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471495932582",
          displayOrder: 52,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Insights",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471495283394",
          displayOrder: 53,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
        {
          columnValue1: "Search",
          columnValue2: "Yes",
          columnValue3: "Yes",
          columnValue4: "Yes",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471494641816",
          displayOrder: 54,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
      ],
      tableHeaders: [
        {
          columnValue1: "Features",
          columnValue2: "Standard User",
          columnValue3: "Content Creator",
          columnValue4: "Business User",
          columnValue5: "",
          columnValue6: "",
          columnValue7: "",
          columnValue8: "",
          columnValue9: "",
          columnValue10: "",
          columnValue11: "",
          columnValue12: "",
          columnValue13: "",
          columnValue14: "",
          columnValue15: "",
          columnValue16: "",
          columnValue17: "",
          columnValue18: "",
          columnValue19: "",
          columnValue20: "",
          partitionKey: "2516970471605783016",
          rowKey: "2516970471528900627",
          displayOrder: 0,
          isValid: true,
          version: "V1",
          errorMessage: null,
          status: null,
          timestamp: null,
        },
      ],
      partitionKey: "2516970471716143878",
      rowKey: "2516970471605783016",
      displayOrder: 2,
      isValid: true,
      version: "V1",
      errorMessage: null,
      status: "",
      timestamp: null,
    },
  ];

  tableModels = [
    {
      tableHeading: "Standard User Plan Details",
      tableHeaders: [
        {
          columnValue1: "Plan Description",
        },
      ],
      tableRowModels: [
        {
          columnValue1: `Standard Plan — Perfect for individuals who want to explore and learn from existing flows created by others. You’ll have full access to view any public flow on the platform, but you won’t be able to create or publish your own.`,
          // columnValue2:'Standard Plan — View any available flows on the platform. Creating flows is not permitted.'
        },
      ],
    },
    {
      tableHeading: "Creator Plan Details",
      tableHeaders: [
        {
          columnValue1: "Plan Description",
        },
      ],
      tableRowModels: [
        {
          columnValue1: `Creator Plan — Designed for users who want to build and share their own step-by-step guides. You can publish flows for free or sell them to others. The platform will take a small commission on each sale to support hosting and reach.`,
          // columnValue2:
          //   "Creator Plan — Create and publish your own flows. Earnings from flow sales are shared with a platform commission.",
        },
      ],
    },
    {
      tableHeading: "Business Plan",
      tableHeaders: [
        {
          columnValue1: "Plan",
          columnValue2: "Price",
          columnValue3: "Target Audience",
          columnValue4: "Included Guides",
        },
      ],
      tableRowModels: [
        {
          columnValue1: "Starter (Product-Led Entry)",
          columnValue2: "£99/mo",
          columnValue3: "Early-stage brands or pilot projects",
          columnValue4:
            "Up to 3 guides / month (10 steps each) | Up to 2,000 monthly views (£0.02 per extra view) | Guide top-ups available",
        },
        {
          columnValue1: "Growth (Most Popular)",
          columnValue2: "£399/mo",
          columnValue3: "Established DTC brands or retailers",
          columnValue4:
            "Up to 20 guides / month (avg. 12–15 steps each) | Up to 15,000 monthly views (£0.02 per extra view) | Guide top-ups available",
        },
        {
          columnValue1: "Enterprise",
          columnValue2: "Custom",
          columnValue3: "Large retailers, manufacturers (e.g., IKEA, Wren)",
          columnValue4: "Unlimited guides + steps ",
        },
      ],
    },
  ];
  mainheaderRow: any;
  noResultReturned: boolean;
  isAnnual: boolean = false;
  isNavigatingToCheckout = false;
  starterMonthlyPrice: number = 99;
  growthMonthlyPrice: number = 399;
  userData: any = null;
  isLoggedIn: boolean = false;
  isSuperAdmin: boolean = false;
  /** Where to send the user back after a purchase (e.g. manual/smart create). */
  returnUrl: string | null = null;
  hasJoinedCreatorPlan = false;
  coinPacks: AiCoinPack[] = [...DEFAULT_AI_COIN_PACKS];
  coinBalance: AiCoinBalance | null = null;
  guidePacks: GuideSlotPack[] = [...DEFAULT_GUIDE_SLOT_PACKS];
  guideBalance: GuideSlotBalance | null = null;
  planConfig: PlanConfigModel = mergePlanConfig();
  trialStatus: TrialStatusModel | null = null;

  get starterGuideLine(): string {
    return starterGuideFeature(this.planConfig);
  }

  get starterViewsLine(): string {
    return starterViewsFeature(this.planConfig);
  }

  get growthGuideLine(): string {
    return growthGuideFeature(this.planConfig);
  }

  get growthViewsLine(): string {
    return growthViewsFeature(this.planConfig);
  }

  get starterCoinsLine(): string {
    return starterCoinsFeature(this.planConfig);
  }

  get growthCoinsLine(): string {
    return growthCoinsFeature(this.planConfig);
  }

  get overageRatesLine(): string {
    return formatOverageRates(this.planConfig);
  }

  constructor(
    private getcontentService: GetContentService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private authModalService: AuthModalService,
    private permissionsService: PermissionsService,
    private aiCoinService: AiCoinService,
    private guideSlotService: GuideSlotService,
    private subscriptionService: SubscriptionService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private trialStateService: TrialStateService,
    private orgContext: OrgContextService
  ) {}

  async getPricingPageDetails() {
    this.noResultReturned = true;
    this.isLoading = true;
    var contentQueryModel = new ContentQueryModel({
      applicationKey: prodcmsconfig.applicationKey,
      environmentKey: prodcmsconfig.environmentKey,
      contentType: ContentTypes.Pricing,
      recaptchaValue: prodcmsconfig.environmentKey,
    });

    (
      await this.getcontentService.getContentByContentQueryModel(
        contentQueryModel
      )
    ).subscribe((data) => {
      this.pricing = data;
      // Filter out "Feature Comparison" table
      this.tables = (data[0].tablesModels || []).filter(
        (table: any) => table.tableHeading !== "Feature Comparison"
      );
      //this.maintableRowModels = data[0].tablesModels[0].tableRowModels.splice(1, data[0].tablesModels[0].tableRowModels.length - 1);
      this.noResultReturned = false;
    });
  }

  toggleBilling() {
    this.isAnnual = !this.isAnnual;
  }

  getStarterAmount(): number {
    return this.isAnnual
      ? Math.round(this.starterMonthlyPrice * 0.8)
      : this.starterMonthlyPrice;
  }

  getGrowthAmount(): number {
    return this.isAnnual
      ? Math.round(this.growthMonthlyPrice * 0.8)
      : this.growthMonthlyPrice;
  }

  startExploring(): void {
    this.router.navigate(["/"]);
  }

  /** Creator Network is for public accounts; organization accounts publish under their org plan. */
  get showCreatorPlan(): boolean {
    return !this.orgContext.isOrganizationMode();
  }

  private refreshCreatorPlanStatus(): void {
    const plan = String(
      this.userData?.effectivePlanId || this.userData?.EffectivePlanId || ""
    )
      .trim()
      .toLowerCase();
    this.hasJoinedCreatorPlan = plan === "creator";
  }

  joinCreatorNetwork(): void {
    if (this.hasJoinedCreatorPlan) {
      return;
    }
    if (!this.isLoggedIn) {
      this.authModalService.openModal("registration", this.router.url);
      return;
    }
    if (this.isSuperAdmin) {
      return;
    }

    const dialogRef = this.dialog.open(CreatorPlanConfirmDialogComponent, {
      width: "480px",
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "creator-plan-confirm-pane",
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result || result === false || !result.confirmed) {
        return;
      }

      updateLoggedInUser({
        userType: result.userType,
        UserType: result.userType,
        effectivePlanId: result.effectivePlanId,
        EffectivePlanId: result.effectivePlanId,
        requiresPaidCreation: result.requiresPaidCreation,
      });
      this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
      this.refreshCreatorPlanStatus();
      this.permissionsService.refresh(this.userData).subscribe({
        next: () => {
          this.toastr.success(
            "Welcome to the Creator Network! Creator plan activated."
          );
          this.openCreateDialogs();
        },
        error: () => {
          this.toastr.success(
            "Welcome to the Creator Network! Creator plan activated."
          );
          this.openCreateDialogs();
        },
      });
    });
  }

  /** Opens the Create New dialog (flow / bundle), then navigates into create flows. */
  private openCreateDialogs(): void {
    localStorage.removeItem("ItemsRequired");
    localStorage.removeItem("flowCoverPageDetails");
    localStorage.removeItem("SupportingDocumentDocuments");
    localStorage.removeItem("SupportingDocumentHyperLinksRequired");
    localStorage.removeItem("stepsCoverPageDetails");
    localStorage.removeItem("draftWord");
    localStorage.removeItem("editWord");

    const dialogRef = this.dialog.open(BundledialogComponent, {
      panelClass: "dialoguebox",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "bundle") {
        localStorage.setItem(
          "navigatebackfromcreatebundle",
          this.location.path()
        );
        localStorage.removeItem("createbundledetails");
        localStorage.removeItem("addbundleselectedflows");
        this.router.navigate(["/create-guide-pack"]);
      } else if (result === "flowchest-ai-create" || result === "quick-create") {
        localStorage.setItem(
          "navigatebackfromcreateflow",
          this.location.path()
        );
        this.router.navigate(["/create-guide/quick"]);
      } else if (result === "manual-create") {
        localStorage.setItem(
          "navigatebackfromcreateflow",
          this.location.path()
        );
        this.router.navigate(["/create-guide/manual"]);
      } else if (result === "flow") {
        localStorage.setItem(
          "navigatebackfromcreateflow",
          this.location.path()
        );
        this.router.navigate(["/create-guide/selection"]);
      }
    });
  }

  get trialConfig() {
    return getTrialConfig(this.planConfig);
  }

  /** One-line trial summary for the Starter card, e.g. "1 guide · manual creation · cancel anytime". */
  get starterTrialSummary(): string {
    const trial = this.trialConfig;
    return [
      `${trial.maxGuides} guide${trial.maxGuides === 1 ? "" : "s"}`,
      trial.allowAi ? "manual + AI" : "manual creation",
      "cancel anytime",
    ].join(" · ");
  }

  /** Logged-out visitors see the trial CTA; eligibility is re-checked at checkout. */
  get showStarterTrial(): boolean {
    if (!this.isLoggedIn) return true;
    if (this.trialStatus?.active) return false;
    return isTrialEligible();
  }

  get trialActive(): boolean {
    return this.trialStatus?.active === true;
  }

  get trialDaysLeft(): number {
    return this.trialStatus?.daysLeft ?? 0;
  }

  startStarterTrial(): void {
    this.selectPlan("starter", true);
  }

  private loadTrialStatus(): void {
    if (!this.isLoggedIn) {
      return;
    }
    this.trialStatus = this.trialStateService.snapshot;
    this.trialStateService.refresh().subscribe((status) => {
      this.trialStatus = status;
    });
  }

  /** Reminder links (?trial=reminder) land here: switch to annual to show the yearly saving. */
  private maybeHighlightTrialReminder(): void {
    if (this.route.snapshot.queryParamMap.get("trial") !== "reminder") {
      return;
    }
    this.isAnnual = true;
    setTimeout(() => {
      document.querySelector(".business-solutions")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
  }

  selectPlan(planName: string, startTrial = false): void {
    if (planName !== "starter" && planName !== "growth") {
      return;
    }
    if (this.isNavigatingToCheckout) {
      return;
    }

    // Re-read auth on click — ngOnInit flags can be stale after login/logout.
    let user: any = null;
    try {
      const raw = localStorage.getItem("LoggedInUser");
      user = raw ? JSON.parse(raw) : null;
    } catch {
      user = null;
    }
    this.userData = user;
    this.isLoggedIn = !!user;
    this.isSuperAdmin = user?.userRole === "Super Admin";

    const queryParams = new URLSearchParams({
      plan: planName,
      billing: this.isAnnual ? "annual" : "monthly",
    });
    if (this.returnUrl) {
      queryParams.set("returnUrl", this.returnUrl);
    }
    if (startTrial && planName === "starter") {
      queryParams.set("trial", "1");
    }

    const checkoutUrl = `/subscriptions?${queryParams.toString()}`;

    if (!this.isLoggedIn) {
      // After sign-in, continue to checkout for the selected plan (not back to /pricing).
      this.authModalService.openModal("registration", checkoutUrl);
      return;
    }

    this.isNavigatingToCheckout = true;
    // navigateByUrl is more reliable than navigate()+queryParams for this flow.
    void this.router.navigateByUrl(checkoutUrl).then(
      (ok) => {
        this.isNavigatingToCheckout = false;
        if (!ok) {
          this.toastr.error(
            "Could not open checkout. Please try again.",
            "Navigation failed"
          );
        }
      },
      () => {
        this.isNavigatingToCheckout = false;
        this.toastr.error(
          "Could not open checkout. Please try again.",
          "Navigation failed"
        );
      }
    );
  }

  ngOnInit(): void {
    this.loadPlanConfig();
    this.returnUrl = resolveCoinPurchaseReturnUrl(
      this.route.snapshot.queryParamMap.get("returnUrl")
    );
    if (this.returnUrl) {
      setCoinPurchaseReturnUrl(this.returnUrl);
    }
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.isLoggedIn = this.userData != null;
    this.isSuperAdmin = this.userData?.userRole === "Super Admin";
    this.refreshCreatorPlanStatus();
    this.loadCoinPacks();
    this.loadGuidePacks();

    // Filter out "Feature Comparison" from default tables
    this.tables = this.tables.filter(
      (table: any) => table.tableHeading !== "Feature Comparison"
    );
    // this.getPricingPageDetails();

    this.maybeOpenCoinPurchaseDialog();
    this.maybeOpenGuidePurchaseDialog();
    this.maybeHighlightUpgradeForFreeContent();
    this.loadTrialStatus();
    this.maybeHighlightTrialReminder();
  }

  /** Opens the Upgrade Plan modal when arriving from manual/smart create. */
  private maybeHighlightUpgradeForFreeContent(): void {
    if (this.route.snapshot.queryParamMap.get("upgradeFree") !== "1") {
      return;
    }

    setTimeout(() => {
      this.openUpgradePlanDialog();
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { upgradeFree: null, returnUrl: null },
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
    }, 300);
  }

  openUpgradePlanDialog(): void {
    this.dialog.open(UpgradePlanDialogComponent, {
      width: "780px",
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "upgrade-plan-dialog-pane",
      autoFocus: false,
      data: {
        returnUrl: this.returnUrl,
        isAnnual: this.isAnnual,
      },
    });
  }

  /** Opens coin pack modal when arriving from Smart Create (buyCoins=1 or #ai-coins). */
  private maybeOpenCoinPurchaseDialog(): void {
    const buyCoins =
      this.route.snapshot.queryParamMap.get("buyCoins") === "1";
    const fragment = this.route.snapshot.fragment;
    const openFromFragment = fragment === "ai-coins";

    if (!buyCoins && !openFromFragment) {
      return;
    }

    // Wait for packs/balance load, then open once.
    setTimeout(() => this.openAiCoinPurchaseDialog(), 250);

    if (buyCoins) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { buyCoins: null, returnUrl: null },
        queryParamsHandling: "merge",
        fragment: "ai-coins",
        replaceUrl: true,
      });
    }
  }

  openAiCoinPurchaseDialog(selectedPackId?: string): void {
    const returnUrl = resolveCoinPurchaseReturnUrl(this.returnUrl || this.router.url);
    if (returnUrl) {
      setCoinPurchaseReturnUrl(returnUrl);
    }

    this.dialog.open(AiCoinPurchaseDialogComponent, {
      width: "680px",
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "ai-coin-purchase-dialog-pane",
      autoFocus: false,
      data: {
        packs: this.coinPacks,
        balance: this.coinBalance,
        selectedPackId: selectedPackId || this.coinPacks[1]?.id || this.coinPacks[0]?.id,
        returnUrl,
      },
    });
  }

  loadCoinPacks(): void {
    if (!this.isLoggedIn) {
      this.coinPacks = [...DEFAULT_AI_COIN_PACKS];
      return;
    }

    this.aiCoinService.getBalance().subscribe({
      next: (balance) => {
        this.coinBalance = balance;
        this.coinPacks =
          balance.packs?.length > 0 ? balance.packs : [...DEFAULT_AI_COIN_PACKS];
      },
      error: () => {
        this.coinPacks = [...DEFAULT_AI_COIN_PACKS];
      },
    });
  }

  purchaseCoinPack(packId: string): void {
    this.openAiCoinPurchaseDialog(packId);
  }

  /** Opens guide pack modal when arriving from create/publish (buyGuides=1 or #guide-topups). */
  private maybeOpenGuidePurchaseDialog(): void {
    const buyGuides =
      this.route.snapshot.queryParamMap.get("buyGuides") === "1";
    const fragment = this.route.snapshot.fragment;
    const openFromFragment = fragment === "guide-topups";

    if (!buyGuides && !openFromFragment) {
      return;
    }

    setTimeout(() => this.openGuideSlotPurchaseDialog(), 250);

    if (buyGuides) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { buyGuides: null, returnUrl: null },
        queryParamsHandling: "merge",
        fragment: "guide-topups",
        replaceUrl: true,
      });
    }
  }

  openGuideSlotPurchaseDialog(selectedPackId?: string): void {
    const returnUrl = resolveCoinPurchaseReturnUrl(this.returnUrl || this.router.url);
    if (returnUrl) {
      setCoinPurchaseReturnUrl(returnUrl);
    }

    this.dialog.open(GuideSlotPurchaseDialogComponent, {
      width: "680px",
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "guide-slot-purchase-dialog-pane",
      autoFocus: false,
      data: {
        packs: this.guidePacks,
        balance: this.guideBalance,
        selectedPackId: selectedPackId || this.guidePacks[1]?.id || this.guidePacks[0]?.id,
        returnUrl,
      },
    });
  }

  loadGuidePacks(): void {
    if (!this.isLoggedIn) {
      this.guidePacks = [...DEFAULT_GUIDE_SLOT_PACKS];
      return;
    }

    this.guideSlotService.getBalance().subscribe({
      next: (balance) => {
        this.guideBalance = balance;
        this.guidePacks =
          balance.packs?.length > 0 ? balance.packs : [...DEFAULT_GUIDE_SLOT_PACKS];
      },
      error: () => {
        this.guidePacks = [...DEFAULT_GUIDE_SLOT_PACKS];
      },
    });
  }

  purchaseGuidePack(packId: string): void {
    this.openGuideSlotPurchaseDialog(packId);
  }

  private loadPlanConfig(): void {
    this.subscriptionService.getPlanConfig().subscribe({
      next: (config) => {
        this.planConfig = mergePlanConfig(config);
        this.applyPlanConfigToTables();
      },
      error: () => {
        this.planConfig = mergePlanConfig();
        this.applyPlanConfigToTables();
      },
    });
  }

  private applyPlanConfigToTables(): void {
    const starter = getPlanLimits(this.planConfig, "starter");
    const growth = getPlanLimits(this.planConfig, "growth");
    const viewOverage = formatViewOverageRate(this.planConfig);
    const businessTable = this.tables.find(
      (table: { tableHeading?: string }) => table.tableHeading === "Business Plan"
    );
    if (!businessTable?.tableRowModels?.length) {
      return;
    }

    businessTable.tableRowModels[0].columnValue4 =
      `Up to ${starter.maxPublishedFlows} guides / month (${starter.maxStepsPerFlow} steps each) | Up to ${formatViewsLimit(starter.maxMonthlyViews)} monthly views (${viewOverage})`;
    businessTable.tableRowModels[1].columnValue4 =
      `Up to ${growth.maxPublishedFlows} guides / month (avg. 12–15 steps each) | Up to ${formatViewsLimit(growth.maxMonthlyViews)} monthly views (${viewOverage})`;
  }
}
